<template>
  <div class="process-template">
    <div class="search-group">
      <div class="input-box">
        <el-input
          size="mini"
          placeholder="请输入单元名称"
          v-model="unitName">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <el-button type="primary" size="mini" @click="doSearch">{{"搜索"}}</el-button>
      <el-button type="primary" size="mini" @click="showDialog">{{"新增"}}</el-button>
    </div>
    <div class="table-box">
      <cc-table
        :config="tableConfig"
        :params="tableConfigParams"
        :refesh-params="tableRefresh"
      ></cc-table>
    </div>
    <el-dialog :title="`${form.id === '' ? '新增' : '编辑'}绑定`"
               v-loading="dialogLoading"
               :visible.sync="dialogVisible"
               width="40%"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               @closed="closeDialog"
               append-to-body>
      <el-form
        :model="form"
        :rules="rules"
        size="mini"
        label-width="80px"
        ref="form"
        @submit.native.prevent
        v-loading="loading">
        <el-form-item :label="'单元'" prop="unitName">
          <el-input
            v-model="form.unitName"
            placeholder="请输入单元名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$lange === 'en' ? 'Class' : '负责班级'"
          :required="true"
          v-if="showTree"
          style="max-height: 200px; overflow: auto"
        >
          <el-select
            v-model="form.deptId"
            clearable
            :placeholder="language('workShop.请选择机械部门')"
          >
            <el-option
              v-for="item in classList"
              :label="item.fullname"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="form.deptId2"
            clearable
            style="margin: 0 10px"
            :placeholder="language('workShop.请选择电气部门')"
          >
            <el-option
              v-for="item in classList2"
              :label="item.fullname"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="form.deptId3"
            clearable
            :placeholder="language('workShop.请选择调试部门')"
          >
            <el-option
              v-for="item in classList3"
              :label="item.fullname"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click.prevent="submitForm('form')">{{"提交" }}</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'ProcessTemplate',
    data() {
      return {
        tplId: '',
        loading: false,
        dialogLoading: false,
        tableDataLoading: false,
        tableRefresh: 1,
        unitName: '',
        dialogVisible: false,
        showTree: true,
        classList: [],
        classList2: [],
        classList3: [],
        form: {
          id: '',
          deptId: '',
          deptId2: '',
          deptId3: '',
          unitName: ''
        },
        rules: {
          unitName: [{ required: true, message: "请输入单元名称", trigger: "blur" }]
        },
        tableConfigParams: {
          unitName: ''
        },
        tableConfig: {
          showPager: true,
          pageSize: 10,
          api: "admin/fsb/unit/bind/query",
          columns: [
            {prop: 'unitName', lable: '单元名称', type: 'input'},
            {prop: 'teamsName', lable: '负责班级', type: 'input'},
            {prop: 'createUserName', lable: '创建者', type: 'input'},
            {prop: 'updateUserName', lable: '修改者', type: 'input'},
            {prop: 'createTime', lable: '创建时间', type: 'input'},
            {prop: 'updateTime', lable: '修改时间', type: 'input'}
          ],
          buttonsLabel: '操作',
          buttons: [
            {
              name: '编辑',
              click: (row) => {
                this.dialogLoading = true;
                this.showDialog();
                this.$nextTick(() => {
                  this.ccRequest
                    .do('admin/fsb/unit/bind/find', {
                      'id': row.id,
                    }, 'GET').then((res) => {
                      this.form.id = res.data.id;
                      this.form.unitName = res.data.unitName;
                      let deptId = res.data.teams.split(',')[0];
                      let deptId2 = res.data.teams.split(',')[1];
                      let deptId3 = res.data.teams.split(',')[2];
                      this.form.deptId = deptId === '0' ? '' : parseInt(deptId);
                      this.form.deptId2 = deptId2 === '0' ? '' : parseInt(deptId2);
                      this.form.deptId3 = deptId3 === '0' ? '' : parseInt(deptId3);
                      this.dialogLoading = false;
                  });

                });
              },
            },
            {
              name: '删除',
              click: (row) => {
                this.$confirm(`确定删除'${row.unitName}'绑定?`, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }).then(() => {
                  this.ccRequest
                    .do(`admin/fsb/unit/bind/delete`,{
                      id: row.id
                    }, "GET").then(() => {
                      this.tableRefresh = new Date().getTime();
                      this.$message({message: "删除成功", type: "success"});
                    }).catch((err) => {
                      this.$message.error(err.response.data.message);
                    });
                });
              },
            }
          ],
        }
      }
    },
    methods: {
      initForm() {
        this.form.id = '';
        this.form.deptId = '';
        this.form.deptId2 = '';
        this.form.deptId3 = '';
        this.form.unitName = '';
      },
      doSearch() {
        this.tableConfigParams.unitName = this.unitName;
      },
      showDialog() {
        this.dialogVisible = true;
        this.getClassList();
      },
      closeDialog() {
        this.dialogLoading = false;
        this.dialogVisible = false;
        this.$refs.form.resetFields();
        this.initForm();
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.form.deptId === '' && this.form.deptId2 === '' && this.form.deptId3 === '') {
              this.$message.error('至少选择一个负责班级绑定');
              return false;
            }
            let deptId = [0, 0, 0];
            if (this.form.deptId) {
              deptId[0] = this.form.deptId;
            }
            if (this.form.deptId2) {
              deptId[1] = this.form.deptId2;
            }
            if (this.form.deptId3) {
              deptId[2] = this.form.deptId3;
            }
            this.ccRequest
              .do('admin/fsb/unit/bind/save', {
                id: this.form.id,
                teams: deptId.join(","),
                unitName: this.form.unitName
              }, 'POSTJSON')
              .then(() => {
                this.closeDialog();
                this.tableRefresh = new Date().getTime();
                this.$message({message: '保存成功', type: 'success'});
              })
              .catch((err) => {
                this.$message.error(err.response.data.message);
              });
          }
        });
      },
      async getClassList() {
        this.classList = await this.getDeptListByType(1);
        this.classList2 = await this.getDeptListByType(2);
        this.classList3 = await this.getDeptListByType(3);

      },
      async getDeptListByType(type) {
        return await this.ccRequest.do("admin/fsb/workshop/unit/getDeptListByType", {type: type}, "GET");
      }
    }
  }
</script>

<style scoped lang="scss">
.el-upload__tip {
  position: absolute;
  top: 50px;
  color: red;
}
.process-template {
  background: #fff;
  padding: 20px;

  .input-box {
    margin-right: 20px;
  }

  .search-group {
    display: flex;
    margin-bottom: 20px;
  }
}

::v-deep .el-table .el-table__cell {
  padding: 6px 0;
}

</style>
